const dateSorterDatatable = (date1, date2) => {
  const a1 = new Date(date1).getTime()
  const b1 = new Date(date2).getTime()
  if (a1 < b1) return 1
  else if (a1 > b1) return -1
  else return 0
}

export default dateSorterDatatable
